import LogoPasmik from 'assets/icons/PasarMIKRO-Primary-Logogram-3.svg'
import BcaLogo from 'assets/images/BCA-01.png'
import BriLogo from 'assets/images/BRI-01.png'
import axios from 'axios'
import CustomButton from 'components/Buttons/CustomButton'
import { apiEndpoint } from 'configs'
import { useEffect, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import {
  AlertCircle,
  AlertTriangle,
  ChevronDown,
  ChevronUp,
} from 'react-feather'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardTitle,
  Collapse,
  Container,
  FormGroup,
  Label,
  Modal,
  ModalBody,
} from 'reactstrap'
import ModalPendingTopup from './ModalPending'
import { useSelector } from 'react-redux'
import { useFetchPendingBcaAllQuery } from 'features/private-views/topup/topupApiSlice'

const Instruction = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const dataState = location.state

  const { ownerData } = useSelector((s) => s.dashboard)
  const auth = useSelector((s) => s.auth)

  const { data: pendingBcaAllData } = useFetchPendingBcaAllQuery(undefined, { skip: !auth?.token })
  const pendingBcaList = Array.isArray(pendingBcaAllData)
    ? pendingBcaAllData
    : pendingBcaAllData?.data || pendingBcaAllData?.items || []

  const [dataState2, setDataState2] = useState(dataState)
  const [errMsg, setErrMsg] = useState('')
  const [loading, setLoading] = useState(false)
  const [isOpenModalPending, setIsOpenModalPending] = useState(false)
  const toggleModalPending = () => setIsOpenModalPending(!isOpenModalPending)
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false)
  const toggleModalConfirm = () => setIsOpenModalConfirm(!isOpenModalConfirm)
  const instructionsBca = [
    {
      title: 'ATM BCA',
      content: [
        'Masukkan kartu ATM dan PIN BCA kamu.',
        'Pilih menu "Transaksi Lainnya".',
        'Pilih menu "Transfer".',
        'Pilih "Ke Rek BCA".',
        'Masukkan nomor rekening tujuan.',
        'Masukkan nominal transfer.',
        'Konfirmasi transfer.',
      ],
    },
    {
      title: 'BCA Mobile',
      content: [
        'Login ke akun BCA mobile kamu.',
        'Pilih menu "m-Transfer".',
        'Pilih "Transfer Antar Rekening"',
        `Jika belum terdaftar, silakan daftarkan nomor rekeningnya terlebih dahulu.`,
        'Masukkan nominal transfer.',
        'Klik "Lanjut" dan selesaikan transfer.',
      ],
    },
    {
      title: 'myBCA',
      content: [
        'Login ke akun myBCA kamu.',
        'Pilih menu "Transaksi".',
        'Pilih submenu "Transfer".',
        'Masukkan nomor rekening tujuan.',
        'Masukkan nominal transfer.',
        'Klik "Lanjut".',
        'Pastikan data transfer sudah benar, lalu pilih "Ya" untuk memverifikasi transaksi.',
        'Tunggu notifikasi transaksi berhasil.',
      ],
    },
    {
      title: 'KlikBCA',
      content: [
        'Kunjungi website ini KlikBCA.',
        'Login ke akun KlikBCA kamu.',
        'Pilih menu "Transfer Dana".',
        'Pilih "Transfer ke Rekening BCA".',
        'Pilih nomor rekening dari daftar, daftarkan jika belum.',
        'Masukkan nominal transfer.',
        'Aktifkan KeyBCA, masukkan pin dan tekan angka 2.',
        'Masukkan 8 digit dari Respon KeyBCA APPLI 2.',
        'Klik Lanjutkan.',
        'Tunggu informasi rekening tujuan.',
        'Nyalakan KeyBCA kembali.',
        'Klik angka 1.',
        'Tunggu 8 digit di kotak Respon KeyBCA APPLI 1.',
        'Pilih "Kirim".',
      ],
    },
  ]
  const instructionsBri = [
    {
      title: 'ATM BRI',
      content: [
        'Masukkan Kartu Debit Anda ke dalam mesin ATM.',
        'Pilih Bahasa. ',
        'Masukkan PIN. ',
        'PIlih "TRANSAKSI LAIN". ',
        'Pilih "PEMBAYARAN". ',
        'Pilih "LAINNYA". ',
        'Pilih "BRIVA". ',
        'Masukkan nomor Virtual Account Anda (10441 + No Handphone Anda, contoh: 104410812*****), kemudian tekan "BENAR". ',
        'Masukkan jumlah top up yang diinginkan. ',
        'Muncul layar konfirmasi transfer yang berisi\n* NO. BRIVA\n* INSTANSI\n* NAMA\n* KETERANGAN\n* JML PEMBAYARAN\n* PEMBAYARAN\nJika sudah benar, tekan "YA". ',
        'Transaksi sudah selesai, silakan melakukan konfirmasi di aplikasi',
      ],
    },
    {
      title: 'Mobile Banking BRI',
      content: [
        'Masukkan ke dalam Aplikasi BRI Mobile & Pilih Mobile Banking BRI.',
        'Pilih menu "Info".',
        'Pilih menu "Info BRIVA".',
        'Masukkan nomor BRIVA Anda (10441 + No Handphone Anda, contoh: 104410812*****), kemudian tekan "BENAR".',
        'Masukkan jumlah top up yang diinginkan',
        'Masukkan PIN.',
        'Transaksi sudah selesai, silakan melakukan konfirmasi di aplikasi',
      ],
    },
    {
      title: 'Internet Banking BRI',
      content: [
        'Login pada alamat Internet Banking BRI.',
        'Pilih menu "PEMBAYARAN & PEMBELIAN".',
        'Pilih menu "BRIVA".',
        'Isi kode bayar dengan nomor Virtual Account Anda (10441 + No Handphone Anda, contoh: 104410812*****), kemudian tekan "Kirim".',
        'Masukkan jumlah top up yang diinginkan.',
        'Muncul layar konfirmasi pembayaran BRIVA\nJika sudah benar, masukkan Password dan mToken',
        'Transaksi sudah selesai, silakan melakukan konfirmasi di aplikasi',
      ],
    },
    {
      title: 'Mini ATM BRI',
      content: [
        'Pilih menu "Mini ATM".',
        'Pilih menu "Pembayaran".',
        'Pilih menu "BRIVA".',
        'Swipe kartu ATM.',
        'Masukkan nomor BRIVA Anda (10441 + No Handphone Anda, contoh: 104410812*****).',
        'Masukkan PIN ATM.',
        'Muncul konfirmasi pembayaran.',
        'Transaksi sudah selesai, silakan melakukan konfirmasi di aplikasi',
      ],
    },
    {
      title: 'ATM Bank Lain',
      content: [
        'Masukkan kartu debit Anda ke dalam mesin ATM.',
        'Masukkan PIN.',
        'Pilih menu "TRANSAKSI LAINNYA"',
        'Pilih menu "TRANSFER".',
        'Pilih menu "KE REK BANK LAIN".',
        'Masukkan kode Bank BRI (002) kemudian tekan "BENAR".',
        'Masukkan jumlah topup yang diinginkan.',
        'Masukkan nomor BRIVA Anda (10441 + No Handphone Anda, contoh: 104410812*****).',
        'Muncul layar konfirmasi transfer yang berisi:\n* Nomor Virtual Account Anda\n* Nama Anda\n* Jumlah yang akan ditopup\nJika sudah benar, tekan "BENAR".',
        'Transaksi sudah selesai, silakan melakukan konfirmasi di aplikasi',
      ],
    },
  ]

  const instructionsMandiri = [
    {
      title: "Cara Transfer Mandiri VA via Livin' by Mandiri",
      content: [
        "Buka aplikasi Livin' by Mandiri dan login.",
        'Pilih Pembayaran Baru.',
        'Pilih Multi Payment.',
        'Pilih penyedia jasa.',
        'Masukkan nomor Virtual Account yang lengkap.',
        'Masukkan nominal (jika tidak otomatis).',
        "Cek detail tagihan → Konfirmasi → masukkan PIN Livin'.",
        'Catatan:\nVA Mandiri biasanya otomatis menampilkan nama penerima Pasar Mikro.\nBiaya admin Rp2.500',
      ],
    },
    {
      title: 'Cara Transfer Mandiri VA via ATM Mandiri (alternatif)',
      content: [
        'Masukkan kartu & PIN.',
        'Pilih Bayar/Beli → Multi Payment.',
        'Masukkan Kode Perusahaan (86403) + Nomor VA.',
        'Masukkan nominal → konfirmasi → selesai.',
      ],
    },
    {
      title: 'Transfer dari Bank Lain (ATM/Mobile Banking lain)',
      content: [
        'Pilih menu Transfer ke Bank Lain (BI-FAST misalnya).',
        'Pilih/Masukkan Kode Bank Mandiri: 008.',
        'Masukkan nomor rekening tujuan.',
        'Masukkan nominal dan selesaikan transaksi.',
      ],
    },
  ]

  const instructions =
    dataState?.bankCodeReceiver === 'BCA'
      ? instructionsBca
      : dataState?.bankCodeReceiver === 'MANDIRI'
        ? instructionsMandiri
        : instructionsBri

  const [isOpen, setIsOpen] = useState(Array(instructions.length).fill(false))

  const toggle = (index) => {
    const newIsOpen = [...isOpen]
    newIsOpen[index] = !newIsOpen[index]
    setIsOpen(newIsOpen)
  }

  const formattedUniqueCode = () => {
    const uniqueCode = String(
      dataState?.amountPlusUniqueCode ?? dataState?.totalAmount,
    ).slice(-3)
    return uniqueCode
  }

  const confirmBri = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topups/confirm`,
        {
          customerCode: dataState?.customerCode,
          onepaymentkey: dataState?.token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${dataState?.token}`,
        //   },
        // },
      )
      if (data) {
        navigate('/public-payment-success', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const confirmDpDisbursement = async () => {
    try {
      setLoading(true)
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/topuppg/disbursetopup/${dataState?.id}/confirm`,
        {
          params: {
            onepaymentkey: `${dataState?.token}`,
          },
        },
      )
      if (data?.status?.toLowerCase() === 'processing') {
        toggleModalPending()
      } else if (data?.status?.toLowerCase() === 'failed') {
        navigate('/public-payment-failed', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      } else {
        navigate('/public-payment-success', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const cancelBriVa = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topups/cancel`,
        {
          customerCode: dataState?.customerCode,
          onepaymentkey: dataState?.token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${dataState?.token}`,
        //   },
        // },
      )
      if (
        data?.status?.toLowerCase() === 'canceled' ||
        data?.message === 'success'
      ) {
        navigate('/public-payment-failed', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const cancelBcaUniqueCode = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/bussines/topupuniquecode/cancelbyid`,
        {
          topupuniquecodeId: dataState?.id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      if (
        data?.status?.toLowerCase() === 'canceled' ||
        data?.message === 'success'
      ) {
        navigate('/public-payment-failed', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const cancelBcaVa = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topupbca/cancel`,
        {
          customerCode: dataState?.customerCode,
          onepaymentkey: dataState?.token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${dataState?.token}`,
        //   },
        // },
      )
      if (
        data?.status?.toLowerCase() === 'canceled' ||
        data?.message === 'success'
      ) {
        navigate('/public-payment-failed', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const cancelDpDisbursement = async () => {
    try {
      setLoading(true)
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/topuppg/disbursetopup/${dataState?.id}/cancel`,
        {
          params: {
            onepaymentkey: `${dataState?.token}`,
          },
        },
      )
      if (data?.status?.toLowerCase() === 'done') {
        navigate('/public-payment-success', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      } else if (
        data?.status?.toLowerCase() === 'canceled' ||
        data?.status?.toLowerCase() === 'failed' ||
        data?.message === 'success'
      ) {
        navigate('/public-payment-failed', {
          state: {
            ...dataState2,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const fetchContext = async () => {
    if (!dataState?.token) return
    try {
      setLoading(true)
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/onepaymentpage/context`,
        {
          params: {
            onepaymentkey: `${dataState?.token}`,
          },
        },
      )
      setDataState2({ ...dataState, ...data })
    } catch (error) {
      navigate('/public-payment-expired')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = async () => {
    try {
      if (dataState?.isVa) {
        if (dataState?.bankCodeReceiver === 'BCA') {
          await cancelBcaVa()
        } else if (dataState?.bankCodeReceiver === 'MANDIRI') {
          navigate('/public-payment-failed', {
            state: {
              ...dataState2,
            },
            replace: true,
          })
        } else {
          await cancelBriVa()
        }
      } else {
        if (dataState?.transferTo) {
          await cancelDpDisbursement()
        } else {
          await cancelBcaUniqueCode()
        }
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    }
  }

  const handleDoneTransfer = async () => {
    if (dataState?.isVa && dataState?.bankCodeReceiver === 'BRI') {
      await confirmBri()
    } else if (dataState?.transferTo) {
      await confirmDpDisbursement()
    } else {
      if (!dataState?.token) {
        toggleModalPending()
        return
      }
      try {
        const { data } = await axios.get(
          `${apiEndpoint}/api/v1/onepaymentpage/context`,
          {
            params: {
              onepaymentkey: `${dataState?.token}`,
            },
          },
        )
        setDataState2({ ...dataState, ...data })
        if (
          data?.status?.toLowerCase() === 'done' ||
          data?.status?.toLowerCase() === 'confirmed'
        ) {
          navigate('/public-payment-success', {
            state: {
              ...dataState2,
            },
            replace: true,
          })
        } else {
          toggleModalPending()
        }
      } catch (error) {
        setErrMsg(error?.response?.data?.message ?? error.message)
      }
    }
  }

  useEffect(() => {
    if (dataState?.token) {
      fetchContext()
    }
  }, [])

  useEffect(() => {
    if (
      dataState2?.status?.toLowerCase() === 'done' ||
      dataState2?.status?.toLowerCase() === 'confirmed'
    ) {
      navigate('/public-payment-success', {
        state: {
          ...dataState2,
        },
        replace: true,
      })
    } else if (
      dataState2?.status?.toLowerCase() === 'failed' ||
      dataState2?.status?.toLowerCase() === 'canceled'
    ) {
      navigate('/public-payment-failed', {
        state: {
          ...dataState2,
        },
        replace: true,
      })
    }
  }, [dataState2])

  return (
    <div className="flex-centered" style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Container className="custom-container rounded" style={{ backgroundColor: 'transparent' }}>
        <ModalPendingTopup
          isOpen={isOpenModalPending}
          toggle={toggleModalPending}
        />
        <Modal
          centered
          size="sm"
          isOpen={isOpenModalConfirm}
          toggle={toggleModalConfirm}
          data-testid="payment-instruction-cancel-modal"
        >
          <ModalBody className="d-flex flex-column">
            <p className="fw-semibold">Batalkan pembayaran</p>
            <p className="small">
              Anda yakin untuk membatalkan pembayaran ini?
            </p>
            <div className="d-flex gap-2">
              <CustomButton
                testId="payment-instruction-cancel-back-button"
                block
                outline
                disabled={loading}
                color="primary"
                onClick={() => toggleModalConfirm()}
              >
                Kembali
              </CustomButton>
              <CustomButton
                testId="payment-instruction-cancel-yes-button"
                disabled={loading}
                block
                color="primary"
                onClick={() => handleCancel()}
              >
                Ya, Batalkan
              </CustomButton>
            </div>
          </ModalBody>
        </Modal>
        <div className="d-flex flex-column gap-3 py-3">
          <div className="flex-centered py-3">
            {' '}
            <img
              style={{ width: '100%', maxWidth: '200px', height: 'auto' }}
              src={LogoPasmik}
              alt="PasarMIKRO logo"
            />{' '}
          </div>
          <div>
            <Card
              body
              className="border-0 p-4"
              style={{
                borderRadius: '16px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.05)'
              }}
            >
              <CardTitle className="fw-bold mb-4 text-dark">
                Transfer ke {dataState?.isVa ? 'Virtual Account' : 'rekening'}
              </CardTitle>
              <div className="d-flex flex-row gap-3 align-items-center mb-4">
                <div
                  className="p-1 rounded border d-flex align-items-center justify-content-center"
                  style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#fff',
                  }}
                >
                  <img
                    style={{ height: 'auto', width: '100%', maxHeight: '24px', objectFit: 'contain' }}
                    alt={
                      dataState?.bankCodeReceiver
                        ? dataState?.bankCodeReceiver === 'BCA'
                          ? 'bca'
                          : dataState?.bankCodeReceiver === 'MANDIRI'
                            ? 'mandiri'
                            : 'bri'
                        : dataState?.transferTo?.bank_code
                    }
                    src={
                      dataState?.bankCodeReceiver
                        ? dataState?.bankCodeReceiver === 'BCA'
                          ? BcaLogo
                          : dataState?.bankCodeReceiver === 'MANDIRI'
                            ? `${apiEndpoint}/api/v1/publicfile/banks-2-Bank%20Mandiri.jpg`
                            : BriLogo
                        : dataState?.transferTo?.bank_logo
                    }
                  />
                </div>
                <div className="d-flex flex-column justify-content-center">
                  <span className="fw-bold" style={{ color: '#2B7D9A' }}>
                    {dataState?.transferTo?.bank_name
                      ? dataState?.transferTo?.bank_name
                      : `Bank ${dataState?.bankCodeReceiver}`}
                  </span>
                  <span className="text-secondary">
                    {dataState?.bankAccountNameReceiver
                      ? dataState?.bankAccountNameReceiver
                      : dataState?.transferTo?.bank_holder_name}
                  </span>
                </div>
              </div>
              <div>
                <FormGroup className="mb-4">
                  <Label className="fw-600 text-secondary" style={{ fontSize: '14px' }}>
                    Nomor {dataState?.isVa ? 'Virtual Account' : 'rekening'}
                  </Label>
                  <div
                    className="bg-white rounded-3 d-flex justify-content-between align-items-center px-3 border border-light"
                    style={{ height: '56px' }}
                  >
                    <span style={{ color: '#2B7D9A', fontWeight: '600', fontSize: '15px' }}>
                      {!dataState?.isVa
                        ? dataState?.bankAccountNumberReceiver
                          ? dataState?.bankAccountNumberReceiver
                          : dataState?.transferTo?.bank_account_number
                        : dataState?.bankCodeReceiver === 'BCA'
                          ? `14359${dataState?.customerCode}`
                          : dataState?.bankCodeReceiver === 'MANDIRI'
                            ? `86403${ownerData?.phoneNumber || dataState?.ownerData?.phoneNumber || ''}`
                            : `10441${dataState?.customerCode}`}
                    </span>
                    <CopyToClipboard
                      onCopy={() => { }}
                      text={
                        !dataState?.isVa
                          ? dataState?.bankAccountNumberReceiver
                            ? dataState?.bankAccountNumberReceiver
                            : dataState?.transferTo?.bank_account_number
                          : dataState?.bankCodeReceiver === 'BCA'
                            ? `14359${dataState?.customerCode}`
                            : dataState?.bankCodeReceiver === 'MANDIRI'
                              ? `86403${ownerData?.phoneNumber || dataState?.ownerData?.phoneNumber || ''}`
                              : `10441${dataState?.customerCode}`
                      }
                    >
                      <CustomButton
                        testId="payment-instruction-copy-account-button"
                        outline
                        color="secondary"
                        size="sm"
                        className="fw-600 px-3"
                        style={{ borderRadius: '8px', border: '1px solid #dee2e6' }}
                      >
                        Salin
                      </CustomButton>
                    </CopyToClipboard>
                  </div>
                </FormGroup>
              </div>
              <div>
                <FormGroup className="mb-4">
                  <Label className="fw-600 text-secondary" style={{ fontSize: '14px' }}>Jumlah transfer</Label>
                  <div
                    className="bg-white rounded-3 d-flex justify-content-between align-items-center px-3 border border-light"
                    style={{ height: '56px' }}
                  >
                    <span style={{ color: '#2B7D9A', fontWeight: '600', fontSize: '15px' }}>
                      Rp
                      {dataState?.amountPlusUniqueCode ||
                        dataState?.totalAmount ? (
                        (() => {
                          const val = Number(dataState?.amountPlusUniqueCode ?? dataState?.totalAmount);
                          const formatted = intl.formatNumber(val, {
                            useGrouping: 'always',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          });
                          const baseStr = formatted.length > 3 ? formatted.slice(0, -3) : '';
                          const lastThree = formatted.length > 3 ? formatted.slice(-3) : formatted;
                          return (
                            <>
                              {baseStr}
                              <span style={{ color: '#DC6803' }}>
                                {lastThree}
                              </span>
                            </>
                          );
                        })()
                      ) : (
                        intl.formatNumber(Number(dataState?.amount), {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })
                      )}
                    </span>

                    <CopyToClipboard
                      onCopy={() => { }}
                      text={
                        dataState?.amountPlusUniqueCode
                          ? dataState?.amountPlusUniqueCode
                          : dataState?.totalAmount
                            ? dataState?.totalAmount
                            : dataState?.amount
                      }
                    >
                      <CustomButton
                        testId="payment-instruction-copy-amount-button"
                        outline
                        color="secondary"
                        size="sm"
                        className="fw-600 px-3"
                        style={{ borderRadius: '8px', border: '1px solid #dee2e6' }}
                      >
                        Salin
                      </CustomButton>
                    </CopyToClipboard>
                  </div>
                  {!dataState?.isVa && (
                    <span style={{ color: '#DC6803' }}>
                      <AlertTriangle size={20} />{' '}
                      <small>
                        Pastikan nilai transfer sesuai jumlah tertera (termasuk
                        tiga digit terakhir)
                      </small>
                    </span>
                  )}
                </FormGroup>
              </div>
            </Card>
          </div>
          <div>
            {!dataState?.transferTo ? (
              <Card
                body
                className="border-0 p-4 mt-3"
                style={{
                  borderRadius: '16px',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.05)'
                }}
              >
                <CardTitle className="fw-bold mb-4 text-dark">Petunjuk pembayaran</CardTitle>
                <div className="d-flex flex-column gap-2">
                  {instructions?.map((e, i) => {
                    return (
                      <div key={i} className="border rounded-3 bg-white overflow-hidden mb-2" style={{ borderColor: '#e2e8f0' }}>
                        <div
                          onClick={() => toggle(i)}
                          data-testid={`payment-instruction-accordion-${i}`}
                          className="d-flex justify-content-between align-items-center p-3"
                          style={{ cursor: 'pointer', transition: 'background-color 0.2s ease', backgroundColor: isOpen[i] ? '#f8fafc' : '#fff' }}
                        >
                          <span className="fw-600 text-dark">{e?.title}</span>
                          {isOpen[i] ? <ChevronUp size={20} color="#64748b" /> : <ChevronDown size={20} color="#64748b" />}
                        </div>
                        <Collapse isOpen={isOpen[i]}>
                          <div className="p-3 pt-0 border-top bg-white" style={{ borderColor: '#e2e8f0' }}>
                            <div className="d-flex flex-column gap-2 mt-3">
                              {e?.content?.map((z, idx) => {
                                return (
                                  <div key={idx} className="d-flex gap-2">
                                    <div className="text-secondary fw-bold" style={{ minWidth: '20px' }}>{`${idx + 1}.`}</div>
                                    <div className="text-secondary" style={{ lineHeight: '1.5', fontSize: '14px' }}>{z}</div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    )
                  })}
                </div>
              </Card>
            ) : (
              <></>
            )}

            {dataState?.isVa ? (
              <div
                className="py-3 px-3 rounded mt-3"
                style={{ backgroundColor: '#F3FEFF' }}
              >
                Setelah melakukan pembayaran, klik Konfirmasi untuk melanjutkan
                proses.
              </div>
            ) : (
              <></>
            )}
            {errMsg ? (
              <div data-testid="payment-instruction-error-message" className=" mt-3">
                <small className="text-danger">
                  <AlertCircle size={15} /> {errMsg}
                </small>
              </div>
            ) : (
              <></>
            )}
            {/* </Card> */}
          </div>
          <div className="mt-4">
            <CustomButton
              disabled={loading}
              onClick={() => {
                handleDoneTransfer()
              }}
              color="primary"
              block
              className="py-3 fw-bold shadow-sm"
              style={{
                borderRadius: '14px',
                fontSize: '16px',
              }}
            >
              Konfirmasi
            </CustomButton>
          </div>
          <div className="mt-2 mb-4 d-flex flex-column gap-2">
            <CustomButton
              testId="payment-instruction-cancel-button"
              disabled={loading}
              onClick={toggleModalConfirm}
              color="primary"
              outline
              block
              className="py-3 fw-bold"
              style={{
                borderRadius: '14px',
                fontSize: '16px',
              }}
            >
              Batal
            </CustomButton>

            {pendingBcaList?.length > 0 && (
            <CustomButton
              testId="payment-instruction-confirm-button"
              disabled={loading}
                onClick={() => navigate('/topup', { state: { fromInstruction: true, activeTab: '2' } })}
                block
                className="py-3 fw-bold text-secondary bg-transparent border-0"
                style={{
                  borderRadius: '14px',
                  fontSize: '16px',
                  boxShadow: 'none',
                }}
              >
                Daftar menunggu pembayaran
              </CustomButton>
            )}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Instruction
